{
  "decrease": "Уменьшение {fieldLabel}",
  "increase": "Увеличение {fieldLabel}",
  "numberField": "Числовое поле"
}
